import React, { useEffect, useState } from "react";
import ReactECharts from 'echarts-for-react';

function Chart() {

    const [chartData, setChartData] = useState([]);



    useEffect(() => {
        fetch('https://arnowillig.de/solar/getchart.php').then(res => res.json()).then((data) => {


            let option = {
                xAxis: {
                    type: 'category',
                    data: data.Data.sitetime,
                    show: false
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: data.Data.powers,
                        type: 'line',
                        smooth: true
                    }
                ]
            };

//            setChartData(data.Data);
            setChartData(option);

        });
    }, []);


    return (
        <ReactECharts
            option={chartData}
            notMerge={true}
            lazyUpdate={true}
        />
    );
}

export default Chart;
